export enum AutoPayOption {
    DefaultOn = 0,
    CanToggleOn = 1,
    CannotChange = 2
}
